
import { Component, ElementRef, ChangeDetectorRef, ViewChild, OnInit, Input, SecurityContext, Renderer2} from '@angular/core';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from 'src/app/back-office/modules/shared-service.service';
import { TableComponent } from 'src/app/back-office/components/table/table.component';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import { UploadContentComponent } from 'src/app/back-office/components/upload-content/upload-content.component';
import { DialogComponent } from 'src/app/back-office/components/dialog/dialog.component';
import { ProjectSplitingComponent } from 'src/app/back-office/components/edit-project/project-spliting/project-spliting.component';
import { ProjectEditingComponent } from 'src/app/back-office/components/edit-project/project-editing/project-editing.component';
import config from 'config/default.json';
import { ProjectSettingComponent } from 'src/app/back-office/components/project-content/project-setting/project-setting.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-epanel-main',
  templateUrl: './epanel-main.component.html',
  styleUrls: ['./epanel-main.component.scss', '../../back-office/components/table/table.component.scss']
})
export class EpanelMainComponent extends TableComponent{
  constructor(
    private router: Router,
    private elRef:ElementRef,
    private apiService: ApiServiceModule,
    private cdRef: ChangeDetectorRef,
    public sanitizer: DomSanitizer,
    private renderer: Renderer2,
    private helper: HelperModule,
    public dialog: MatDialog,
    private sharedService: SharedService
  ){
    super(sanitizer);
  }
  platformInfos:{[x: string]: any} = {origin: 'epanel', key: 'epl', root: 'EPANEL'}
  acceptedExtention: string[] = [];

  @ViewChild('appUploadContent', { static: false }) appUploadContent!: UploadContentComponent;
  @Input() userInfos: { [x:string]: any } = new Map();
  @Input() epanelPrivateRoutes: string[] = [];
  filterData: { [x:string]: any } = {};
  inProgress: boolean = false;
  services: { [x:string]: any } = {
    '': {
      key: '',
      name: 'Acceuil',
      extention:  [],
    },
    'connect': {
      key: 'connect',
      name: 'Acceuil',
      extention:  [],
    },
    'build-pdf': {
      key: 'build-pdf',
      name: 'Numeriser des documents',
      extention:  ['pdf', 'png', 'jpg', 'jpeg', 'docx', 'heic'],
    },
    'edit-pdf': {
      key: 'edit-pdf',
      name: 'Editer PDF',
      extention:  ['pdf'],
    },
    'pdf-to-docx': {
      key: 'pdf-to-docx',
      name: 'Convertir de PDF vers Docx',
      extention:  ['pdf'],
    },
    'docx-to-pdf': {
      key: 'docx-to-pdf',
      name: 'Convertir de Docx ver PDF',
      extention:  ['docx'],
    }
  };
  service:{ [x:string]: any } = {};


  uniqueFormat:any = [];

  ngOnInit(){
    this.service = this.services[this.userInfos['service']];
    this.userInfos['id_default'] = this.service['key']+'_'+this.userInfos['id_default'];
    if(this.userInfos['connected'] == false && this.epanelPrivateRoutes.includes(this.service['key'])) this.connectStudent(this.service['key']);
  }
  lanchService(serviceKey: string){
    this.service = this.services[serviceKey];
    this.cdRef.detectChanges();
    if(this.userInfos['connected'] == false && this.epanelPrivateRoutes.includes(this.service['key'])) this.connectStudent(this.service['key']);

  }
  connectStudent(serviceKey: string){
    this.router.navigate([serviceKey]).then(() => {
      window.location.reload();
    });
  }
  loadUploadData(uploadResult: any){
    let userInfos = { ...this.userInfos };
    this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/project/load_epanel', userInfos, this.userInfos['access_token']).subscribe((response:any)=>{
      if(response.length > 0){
        const dialogRef = this.dialog.open(ProjectSplitingComponent, {
          maxWidth: '100vw',
          maxHeight: '100vh',
          height: '100%',
          width: '100%',
          panelClass: 'full-screen-modal',
          data: {project: {id: userInfos['id_default'], last_task: 'task-splitting'}, 
            raw_data: response, content_data: [], classify_data: [], user_infos: this.userInfos, platform_infos: this.platformInfos}
        });
        dialogRef.afterClosed().subscribe(result => {
          console.log('The dialog was closed');
        });
      }
      
      this.sharedService.sendData({in_progress: false});
    })
  }
  openSplitingEditing(rowInfos:{ [x:string]: any }){
    this.sharedService.sendData({in_progress: true});
    let data = {
      project: rowInfos, 
      platform_infos: this.platformInfos,
      filter_values: this.platformInfos['origin'] == 'virtualclass'? {id_country: rowInfos['id_country'], id_cycle: rowInfos['id_cycle'], id_region: rowInfos['id_region'], id_vcl_institution: rowInfos['id_vcl_institution']}: null,
    }
    
    this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/project/split_detail', data, this.userInfos['access_token']).subscribe((response:any)=>{
      if(response.status){
        const dialogRef = this.dialog.open(ProjectSplitingComponent, {
          maxWidth: '100vw',
          maxHeight: '100vh',
          height: '100%',
          width: '100%',
          panelClass: 'full-screen-modal',
          data: {project: rowInfos, raw_data: response['raw_data'], content_data: response['content_data'], classify_data: response['classify_data'], user_infos: this.userInfos, platform_infos: this.platformInfos}
        });
        dialogRef.afterClosed().subscribe(result => {
          console.log('The dialog was closed');
        });
      }
      this.sharedService.sendData({in_progress: false});
    })
    
    
  }
  signOut(){
    console.log(this.userInfos)
  }


}
